// extracted by mini-css-extract-plugin
export default {"App":"InviteUser_App__p-iJB","formInvite":"InviteUser_formInvite__djCI5","containerCheckOwnerMail":"InviteUser_containerCheckOwnerMail__IpYdj"};